<template>
    <div>
        <topnav @tosearch="tosearch" :keywords="keyword" :toptype="toptype" types="2" :isSearch="path"></topnav>
        <div class="">
            <div class="" v-if="config">
                <el-image class="topimg" :src="config.rzfw_pic | addurl" fit="fill"></el-image>
            </div>
            <div class="marginauto conwidth topall" >
                <div class="flex justify-start align-center">
                    <div class="" style="color: #959595;font-size: 16px;margin-right: 15px;line-height: 37px;width: 100px;">服务类型：</div>
                    <div class="flex justify-start align-center flex-wrap">
                        <div class="topone pointer" v-for="(item,index) in sortlist" :key="index" @click="tabchange(item.id,index)" :class="item.checked ? 'active':''">{{item.name}}</div>
                    </div>
                </div>
            </div>
            <div v-if="list.length" class="response bggray">
                <div class="conwidth marginauto lall fadeInDown animated">
                    <div v-for="(item,index) in list" :key="index" @click="todetail(item.id)" class="marginauto bg-white flex justify-between align-center lone hvr-float">
                        <div class="limg pointer ">
                            <el-image class="cimg" :src="item.image | addurl" fit="cover"></el-image>
                        </div>
                        <div class="line"></div>
                        <div class="pointer" style="min-height: 123px;padding-left: 30px;width: 80%;">
                            <div>
                                <div class="" style="color: #1d1d1d;font-size: 22px;">{{item.name}}</div>
                                <div class="text-cut2 response" style="margin: 15px 0;min-height: 42px;line-height: 30px">
                                    {{item.content}}
                                </div>
                                <div class="flex justify-between align-center">
                                    <div style="color: rgb(136, 136, 136);font-size: 18px;">
                                        信息来源：<span>{{item.source}}</span> 发布日期：<span>{{item.release_time}}</span>
                                    </div>
                                    <div class="dbtn pointer">
                                        查看详情
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-center res" style="padding-top: 40px;">
                        <el-pagination
                            background
                            layout="prev, pager, next"
                            :pager-count="pagerCount"
                            :hide-on-single-page="true"
                            :page-size="pagesize"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :total="totalnum"
                            >
                            </el-pagination>
                    </div>
                </div>
            </div>
            <div class="" v-if="!list.length && !load">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
        
    </div>
</template>
<script>
export default {
    data() {
        return{
            load: true,
            toptype: 6,
            pagesize: 10,
            totalnum: 100,
            currentPage: 1,
            pagerCount: 7,
            list: [],
            config: '',
            keyword: '',
            path: '/finance',
			sortlist:[],
			type_id:0
        }
    },
    methods:{
		tabchange(id,index){
		    for(let i in this.sortlist){
		        this.sortlist[i].checked = false;
		    }
		    this.sortlist[index].checked = true;
			this.type_id = this.sortlist[index].id
		    this.keyword = '';
		    this.getlist();
		    this.$forceUpdate();
		},
		getsort(){
		    this.$api.index.type_list().then(res => {
		        var sdata = {
		            id: 0,
		            name: '全部'
		        }
		        res.data.unshift(sdata);
		        for(let i in res.data){
		            res.data[i]['checked'] = false;
		        }
		        res.data[0]['checked'] = true;
		        this.sortlist = res.data;
		    })
		},
        todetail(e){
            this.$router.push({path: '/financedetail',query: {id: e}})
        },
        handleSizeChange(){

        },
        handleCurrentChange(currentPage){
            this.currentPage = currentPage;
            this.getlist();
        },
        getlist(){
            // finance_list
            var data = {
                start: this.currentPage,
                page_size: this.pagesize,
                keyword: this.keyword,
				type_id:this.type_id
            }
            this.$api.index.finance_list(data).then(response => {
                this.list = response.data;
                this.totalnum = response.count;
                this.load = false;
            })
        },
        tosearch(data){
            console.log(data)
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
    },
    created(){
		this.getsort()
        if(this.$route.query.keyword){
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist()
        }else{
            this.getlist();
        }
        this.config = JSON.parse(localStorage.getItem('config'))
    }
}
</script>
<style scoped>
	.topall{
	    padding: 45px 0;
	    background-color: #fff;
	}
	.topone{
	    padding: 8px 18px;font-size: 16px;color: #4e4e4e;
	}
    .bggray{
        background-color: #eef1fa;
    }
	.active{
	    background-color: #ebf8ff;
	    border-radius: 4px;color: #1759d8;
	}
    .topimg{
        width: 100%;height: 500px;display: block;
    }
    .dbtn{
        width: 200px;
        height: 45px;text-align: center;
        line-height: 45px;color: #fff;
        background-color: #0e6cec;
        border-radius: 4px;font-size: 16px;
    }
    .lall{
        min-height: 400px;padding-top: 45px;
    }
    .lone{
        width: 1280px;padding: 38px 20px;border-radius: 10px;margin-bottom: 20px;
    }
    .limg{
        height: 123px;width: 185px;
    }
    .cimg{
        width: 160px;height: 123px;
    }
    .line{
        width: 1px;height: 123px;background-color: #eeeeee;
    }
</style>


// WEBPACK FOOTER //
// finance.vue?62faa947